export default __webpack_public_path__ + "static/media/check-in-dark.844717bb.svg";